import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type ResetAttributesFilterProps = ApiMethodBase & {}

export const resetAttributesFilterDefaults = ({
    eventEmitter,
}: ResetAttributesFilterProps) => {
    eventEmitter.emit(Event.resetAttributeFilter);
};
